import { useTranslation } from "react-i18next";
import type { DataCollectionSummary } from "@/api";
import { deleteDataSourceMutation, listDataSourcesQueryKey } from "@/api";
import { useDeleteEntity } from "@/components/build/useDeleteEntity";

/** Delete-with-confirm for a data source row/detail page. */
export function useDeleteDataSource(onDeleted?: () => void) {
  const { t } = useTranslation("dataSources");
  return useDeleteEntity<DataCollectionSummary>({
    mutation: deleteDataSourceMutation(),
    listQueryKey: listDataSourcesQueryKey,
    pathFor: (s) => ({ collection_uuid: s.uuid }),
    messages: { deleted: t("deleted"), deleteFailed: t("deleteFailed") },
    onDeleted,
  });
}
